import React from 'react';
import { Icon, sanitize } from '@honeycomb-npm/honeycomb-react';
import { useSelector } from 'react-redux';
import { State } from '../../redux';
import { content } from '../../utils/contentUtils';

const SuccessPage = () => {
  const { success, unSubscribeSuccess } = content;

  const { isEmailPreference } = useSelector((state: State) => state.mainReducer);

  const successContent = isEmailPreference ? unSubscribeSuccess : success;

  return (
    <div className="row">
      <div className="col-lg-8 col-sm-12">
        <h2>{successContent.successTitle}</h2>
        <div>
          <Icon
            screenreader="Success Icon"
            symbol="messageSuccess32"
            type="svgfile"
          >
            <div dangerouslySetInnerHTML={sanitize(successContent.successMessage)} />
          </Icon>
        </div>
        <div className="mt-4" dangerouslySetInnerHTML={sanitize(successContent.successDesc)} />
      </div>
    </div>
  );
};

export default SuccessPage;
